import Vue from 'vue'
import VueRouter from 'vue-router'
import CreateAccount1 from '@/views/CreateAccount-1.vue'
import CreateAccount2 from '@/views/CreateAccount-2.vue'
import CreateAccount3 from '@/views/CreateAccount-3.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'create-1',
    component: CreateAccount1,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-1',
    name: 'create-1',
    component: CreateAccount1,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-2',
    name: 'create-2',
    component: CreateAccount2,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-3',
    name: 'create-3',
    component: CreateAccount3,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
